import styled, { css } from "styled-components";

// 스켈레톤 로딩 스타일 (유튜브에서 가져온 shimmer 애니메이션)
const shimmer = css`
  background: linear-gradient(
    90deg,
    rgb(231, 231, 231) 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const SkeletonCard = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 9.14px;
  background: rgb(175, 175, 175);
  padding: 20px 16px 15px;
  position: relative;
  overflow: hidden;
`;

export const SkeletonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  .header {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .item {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .footer {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

export const SkeletonText = styled.div<{
  width?: string;
  height?: string;
  marginTop?: string;
}>`
  ${shimmer}
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "14px"};
  border-radius: 4px;
  margin-top: ${({ marginTop }) => marginTop || "0"};
`;

export const SkeletonAvatar = styled.div`
  ${shimmer}
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
`;

export const SkeletonButton = styled.div`
  ${shimmer}
  position: absolute;
  top: 20px;
  right: 16px;
  width: 50px;
  height: 20px;
  border-radius: 7.31px;
`;
